export const debugConsole = (message?: any, ...optionalParams: any[]) => {
  if (import.meta.env.MODE === "development") {
    console.log(message, ...optionalParams);
  }
};
